"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeStatusbar = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const rebass_1 = require("rebass");
const ThemeSelector_1 = require("./ThemeSelector");
const ThemeStatusbar = () => {
    return (react_1.default.createElement(rebass_1.Box, { onClick: (event) => {
            event.stopPropagation();
        } },
        react_1.default.createElement(ThemeSelector_1.ThemeSelector, { size: "small" })));
};
exports.ThemeStatusbar = ThemeStatusbar;
